import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Admin from "./pages/Admin";
import Armadores from "./pages/Armadores";
import Booking from "./pages/Booking";
import SucessoPedido from "./pages/Booking/SucessoPedido";
import AddBooking from "./pages/BookingAdd";
import Bookings from "./pages/Bookings";
import Cadastros from "./pages/Cadastros";
import ConsolidateBooking from "./pages/Consolida";
import Conta from "./pages/Conta";
import AddContainers from "./pages/ContainersAdd";
import Cotacoes from "./pages/Cotacoes";
import Dashboard from "./pages/Dashboard";
import Demandas from "./pages/Demandas";
import EditBooking from "./pages/Edit";
import ShowBooking from "./pages/Edit/show";
import ConsolidaNac from "./pages/EditNAC";
import ForgotPassword from "./pages/ForgotPassword";
import Fornecedores from "./pages/Fornecedores";
import AddFornecedores from "./pages/Fornecedores/list";
import AddFretes from "./pages/FretesAdd";
import Impulsionar from "./pages/Impulsionar";
import ListNac from "./pages/ListNac";
import Login from "./pages/Login";
import Mare from "./pages/Mare";
import MaritimeFreightSearch from "./pages/MaritimeFreightSearch";
import CotacoesNAC from "./pages/Nac";
import SucessoQuotation from "./pages/Nac/Sucesso/quotation_nac_success";
import Negociacoes from "./pages/Negociacoes";
import Pagamentos from "./pages/Pagamentos";
import AddPortos from "./pages/PortosAdd";
import Proposal from "./pages/Proposal";
import Protected from "./pages/Protected";
import QuotesEnginnering from "./pages/QuotesEnginnering";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import AddTaxes from "./pages/TaxesAdd";
import Tracking from "./pages/Tracking";
import Upload from "./pages/Upload";
import UploadContratos from "./pages/UploadContratos";
import api from "./services/api";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [tokenIsValid, setTokenIsValid] = useState(false);

  const token = localStorage.getItem("access_token");

  api
    .get("/auth/verifytoken", {
      headers: {
        authorization: token,
      },
    })
    .then((res) => {
      if (res.data.success) {
        setTokenIsValid(true);
      } else {
        localStorage.removeItem("access_token");
        localStorage.removeItem("user_email");
        setTokenIsValid(false);
      }
    })
    .catch((err) => {
      //tratativa de erro
    });

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Login isLoggedIn={tokenIsValid} />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route
          path="/booking"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Booking />
            </Protected>
          }
        ></Route>

        <Route
          path="/pedido_resultado"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <SucessoPedido />
            </Protected>
          }
        ></Route>

        <Route
          path="/sucesso_quotation"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <SucessoQuotation />
            </Protected>
          }
        ></Route>

        <Route
          path="/conta"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Conta />
            </Protected>
          }
        ></Route>

        <Route
          path="/fornecedores"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Fornecedores />
            </Protected>
          }
        ></Route>

        <Route
          path="/addFornecedor"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <AddFornecedores />
            </Protected>
          }
        ></Route>

        <Route
          path="/bookingAdd"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <AddBooking />
            </Protected>
          }
        ></Route>

        <Route
          path="/taxesAdd"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <AddTaxes />
            </Protected>
          }
        ></Route>

        <Route
          path="/portosAdd"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <AddPortos />
            </Protected>
          }
        ></Route>

        <Route
          path="/containersAdd"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <AddContainers />
            </Protected>
          }
        ></Route>

        <Route
          path="/fretesAdd"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <AddFretes />
            </Protected>
          }
        ></Route>

        <Route
          path="/upload"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Upload />
            </Protected>
          }
        ></Route>

        <Route
          path="/edit/:id"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <EditBooking />
            </Protected>
          }
        ></Route>
        <Route
          path="/showBooking/:id"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <ShowBooking />
            </Protected>
          }
        ></Route>
        <Route
          path="/consolida/:id"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <ConsolidateBooking />
            </Protected>
          }
        ></Route>

        <Route
          path="/quotes-enginner"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <QuotesEnginnering />
            </Protected>
          }
        ></Route>
        <Route
          path="/proposal"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Proposal />
            </Protected>
          }
        ></Route>
         <Route
          path="/schedule"
          element={
            
              <MaritimeFreightSearch />
           
          }
        ></Route>
          <Route
          path="/mare"
          element={
            
              <Mare />
           
          }
        ></Route>
        <Route path="/forgot-password" element={<ForgotPassword />}></Route>
        <Route
          path="/reset-password/:token"
          element={<ResetPassword />}
        ></Route>
        <Route
          path="/dashboard"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Dashboard />
            </Protected>
          }
        ></Route>
        <Route
          path="/bookings"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Bookings />
            </Protected>
          }
        ></Route>
        <Route
          path="/upload-contratos"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <UploadContratos />
            </Protected>
          }
        ></Route>
        <Route
          path="/armadores"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Armadores />
            </Protected>
          }
        ></Route>
        <Route
          path="/pagamentos"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Pagamentos />
            </Protected>
          }
        ></Route>

        <Route
          path="/admin"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Admin />
            </Protected>
          }
        ></Route>

        <Route
          path="/cadastros"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Cadastros />
            </Protected>
          }
        ></Route>

        <Route
          path="/tracking"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Tracking />
            </Protected>
          }
        ></Route>

        <Route
          path="/demandas"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Demandas />
            </Protected>
          }
        ></Route>

        <Route
          path="/negociacoes"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Negociacoes />
            </Protected>
          }
        ></Route>

        <Route
          path="/impulsionar"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <Impulsionar />
            </Protected>
          }
        ></Route>

        <Route
          path="/nac"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <CotacoesNAC />
            </Protected>
          }
        ></Route>

        <Route
          path="/nac/:id"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <ConsolidaNac />
            </Protected>
          }
        ></Route>

        <Route
          path="/list/nac/:id"
          element={
            <Protected isLoggedIn={tokenIsValid}>
              <ListNac />
            </Protected>
          }
        ></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
